import { render } from "./InputEmbed.vue?vue&type=template&id=08e6b721"
import script from "./InputEmbed.vue?vue&type=script&lang=js"
export * from "./InputEmbed.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__